
export enum UserMetaSnapshotWsEventResponseDtoEvent {
  UserMetaSnapshot= 'UserMetaSnapshot',

}